import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme'
import { T } from '@/lib/design'

type ThemeToggleProps = {
  compact?: boolean
  className?: string
}

export function ThemeToggle({ compact = false, className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'
  const Icon = isDark ? Sun : Moon

  return (
    <button
      type="button"
      className={className}
      onClick={toggleTheme}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      style={{
        minWidth: compact ? 34 : '100%',
        height: 34,
        padding: compact ? 0 : '0 11px',
        border: '1px solid var(--border)',
        borderRadius: 8,
        background: 'var(--surface)',
        color: 'var(--dim)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: compact ? 'center' : 'space-between',
        gap: 8,
        fontFamily: T.sans,
        fontSize: 13,
        fontWeight: 750,
        cursor: 'pointer',
      }}
    >
      {!compact && <span>{isDark ? 'Light theme' : 'Dark theme'}</span>}
      <Icon size={15} />
    </button>
  )
}
